export const getDwValue = (shorts) => {
  const Input_DW = 0x0002; // 豆温的索引
  return shorts[Input_DW] / 10.0;
};
  
export const isValidDeviceInfo = (deviceInfo) => {
  return Array.isArray(deviceInfo) && deviceInfo.length > 40;
};

export const getDwRorValue = (shorts) => {
  const Input_DW = 0x0007; // 豆温ror的索引
  return shorts[Input_DW] / 10.0;
};

export const getHJWValue = (shorts) => {
  const Input_DW = 0x0003; // 环境温的索引
  return shorts[Input_DW] / 10.0;
};
export const getRFWValue = (shorts) => {
  const Input_DW = 0x0004; // 热风温的索引
  return shorts[Input_DW] / 10.0;
};
export const getPFWValue = (shorts) => {
  const Input_DW = 0x0005; // 排风温的索引
  return shorts[Input_DW] / 10.0;
};
/**
 * 获取火力值（燃烧值）
 * @param {number[]} shorts 数据
 * @return {number} 火力值（燃烧值）
 */
export const getHotValue = (shorts) => {
  const value = 0x0012; // 假设这是火力值的索引
  return (shorts[value] & 0x00FF); // 返回处理后的值
};

/**
* 获取热风值
* @param {number[]} shorts 数据
* @return {number} 热风值
*/
export const getRfValue = (shorts) => {
  const value = 0x0013; // 假设这是热风值的索引
  return ((shorts[value] & 0xFFFF) & 0x0FFF); // 返回处理后的值
};

/**
* 获取滚筒值
* @param {number[]} shorts 数据
* @return {number} 滚筒值
*/
export const getGtValue = (shorts) => {
  const value = 0x0015; // 假设这是滚筒值的索引
  return ((shorts[value] & 0xFFFF) & 0x0FFF); // 返回处理后的值
};
/**
* 获取冷却值
* @param {number[]} shorts 数据
* @return {number} 滚筒值
*/
export const getLQValue = (shorts) => {
  const value = 0x0014; // 假设这是滚筒值的索引
  return ((shorts[value] & 0xFFFF) & 0x0FFF); // 返回处理后的值
};
